import { makeStyles } from 'tss-react/mui';

import { dFlex, scrollBar } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  box: {
    ...dFlex('space-between', 'initial'),
    flexDirection: 'column',
    height: 'inherit',
    color: theme.primary.p2,
    overflowY: 'auto',
    ...scrollBar,
    paddingRight: 4,
  },
  rangeInfoBox: {
    ...dFlex(),
    flexDirection: 'column',
    gap: 8,
    width: '100%',
  },
  farms: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 16,
    width: '100%',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 8,
    },
  },
  btns: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 16,
    marginTop: 16,
  },
  rangeInfoRow: {
    ...dFlex('space-between'),
    width: '100%',

    [theme.breakpoints.down(Breakpoint.Md)]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 6,
    },
  },
  content: {
    ...dFlex('start'),
    flexDirection: 'column',
    gap: 24,
    width: '100%',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gap: 16,
    },
  },
  item: {
    padding: 0,
    background: 'transparent',
    flexDirection: 'row',
    gap: 4,
  },
  rangeInfo: {
    ...dFlex(),
    gap: 8,
    marginLeft: 'auto',
    paddingRight: 16,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      width: '100%',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      paddingRight: 0,
    },
  },
  counters: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 16,
    width: '100%',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gap: 8,
    },
  },
  tokensWeight: {
    [theme.breakpoints.down(Breakpoint.Sm)]: {
      width: '100%',
    },
  },
  tokenWeight: {
    [theme.breakpoints.down(Breakpoint.Sm)]: {
      width: '100%',
    },
  },
  btn: {
    [theme.breakpoints.down(Breakpoint.Sm)]: {
      padding: 6,
    },
  },
  switchRow: {
    ...dFlex('space-between'),
    width: '100%',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      flexDirection: 'column',
      gap: 8,
    },
  },
  innerTab: {
    padding: 0,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      width: '100%',
      margin: 'auto',
    },
  },
  loader: {
    width: 55,
  },
  statusBox: {
    ...dFlex(),
    gap: 4,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      justifyContent: 'space-between',
      width: '100%',
    },
  },
  farmDetailsBox: {
    ...dFlex(),
    gap: 8,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      justifyContent: 'start',
      flexWrap: 'wrap',
    },
  },
  farmTags: {
    ...dFlex('initial'),
    flexWrap: 'wrap',
    gap: 4,
  },
}));

export default useStyles;
